function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "11",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.774.05A.726.726 0 00.05.774v3.783a3.699 3.699 0 003.698 3.698h4.734L7.02 9.721h-.001a.726.726 0 001.025 1.026h.001l2.702-2.704a.726.726 0 000-1.025L8.043 4.315A.725.725 0 007.018 5.34l1.465 1.466H3.748A2.25 2.25 0 011.5 4.558V.775A.725.725 0 00.774.049z",
  fill: "#757575",
  stroke: "#757575",
  strokeWidth: ".099"
})));